const auth = {
	state: {
    	count: 0,
    	isLoggedIn:false,
    	current_user:null,
    	current_user_token:null
  	},
  	mutations: {
  		attempt_login(state){
  			state.isLoggedIn = true;
  		},
  		set_user(state,user){
  			state.current_user = user;
  		},
  		// update_user(state,user_data){
  		// 	$.extend(true, state.current_user, user_data);
  		// },
  		set_user_token(state,token){
  			state.current_user_token = token;
  			localStorage.setItem('usertoken', token)
  		},
  		logout(state){
  			state.isLoggedIn = false;
  			state.current_user = null;
  			state.current_user_token = null;
  			localStorage.removeItem('usertoken', "");	
  		}
  	}
}

export default auth;
	


// WEBPACK FOOTER //
// ./src/store/auth.js